<template>
    <div>
        <div
            class="bigdata_container"
            id="bigdata"
            v-loading="isLoading"
            element-loading-text="拼命加载中..."
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <div
                id="container"
                class="mymap"
                style="width: 100%; heigh: clac(100vh-70px)"
            ></div>
            <!-- <div class="header"></div> -->
            <div class="customerTop">
                <img
                    src="./assets/img/dateTop2.png"
                    alt=""
                    srcset=""
                />
                <div class="titleFirst"></div>
                <div class="titleSecond"></div>
                <h1>{{this.$store.state.info.orgName}}智慧监控可视化</h1>
            </div>
            <div class="quanp">
                <el-button
                    id="fullScreen"
                    @click="showFullScreen"
                    type="primary"
                    >{{ onFullScreen ? "退出全屏" : "进入全屏" }}</el-button
                >
            </div>
            <div style="position: relative">
                <div class="date-left">
                    <div class="date-date-top">
                        <div class="date-title">
                            <div>活动开展</div>
                        </div>
                        <div class="date-list">
                            <DateLine></DateLine>
                        </div>
                    </div>
                    <div class="date-date-top">
                        <div class="date-title">
                            <div>人脸抓拍</div>
                        </div>
                        <div class="date-list">
                            <SexStatistics></SexStatistics>
                        </div>
                    </div>
                </div>
                <div class="date-center1">
                    <div class="date-date-top">
                        <div class="date-title">
                            <div>视频监控</div>
                        </div>
                        <div class="date-list">
                            <ZheyuanzheLine></ZheyuanzheLine>
                        </div>
                    </div>
                </div>
                <div class="date-center2">
                    <el-button :type="znsbc" @click="znsb">智能设备</el-button>
                    <el-button :type="jkdglc" @click="jkdgl"
                        >监控点管理</el-button
                    >
                    <el-button :type="zyssc" @click="zyss">资源搜索</el-button>
                    <el-button :type="ylhzc" @click="ylhz">养老互助</el-button>
                    <el-button :type="yjyclc" @click="yjycl"
                        >应急预处理</el-button
                    >
                    <el-input
                        placeholder="请输入内容"
                        style="margin-top: 10px; width: 50%"
                        v-if="this.showStatus == true"
                    >
                        <template slot="append">
                            <el-button type="primary" icon="el-icon-search"
                                >搜索</el-button
                            >
                        </template>
                    </el-input>
                </div>
                <div class="date-right">
                    <div class="date-date-top">
                        <div class="date-title">
                            <div>投诉处理</div>
                        </div>
                        <div class="date-list">
                            <Team></Team>
                        </div>
                    </div>
                    <div class="date-date-top">
                        <div class="date-title">
                            <div>交办信息</div>
                        </div>
                        <div class="date-list">
                            <Statistics></Statistics>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_center">
            <div id="container" style="width: 100%; height: 100%"></div>
        </div>
        <!-- 智能设备查看弹窗 -->
        <el-dialog
            title="智能设备"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <span>这是一段信息</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import DateLine from "./components/line.vue"
import ZheyuanzheLine from "./components/zheyuanzheLine.vue"
import SexStatistics from "./components/sexStatistics.vue"
// import ChinaMap from "./components/chinaMap.vue"
import Team from "./components/team.vue"
import Statistics from "./components/statistics.vue"
export default {
    components: {
        DateLine,
        SexStatistics,
        ZheyuanzheLine,
        Team,
        Statistics,
    },
    data() {
        return {
            dialogVisible: false,
            isLoading: false,
            onFullScreen: false,
            showStatus: false, //搜索框状态
            znsbc: "primary",
            jkdglc: "",
            zyssc: "",
            ylhzc: "",
            yjyclc: "",
            map: null,
            polygons: [],
            polygon: [],
            marker: [], //地图标记点
            markers: [],
            recMap: null,
            recIsMap: true,
            equipmentId: 1,
        }
    },
    async mounted() {
        await this.loadMap()
        await this.getDistrictss("341100")
        await this.znsb()
        const self = this
    document.addEventListener(
      "fullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "msfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "mozfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "webkitfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )
    },
    _methods: {
      //渲染区域信息
      getDistrictss(city, chooseCity="") {
        return new Promise((resolve, rejcet) => {
          let self=this
          //根据市获取下一级行政区
          let opts={
            subdistrict: 1,
            extensions: "all",
            showbiz: false, //最后一级返回街道信息
          }
          let tempArr=[]
          let district=new AMap.DistrictSearch(opts) //注意：需要使用插件同步下发功能才能这样直接使用
          district.search(city, function(status, result) {
            if(status=="complete") {
              result.districtList[0].districtList.forEach((item) => {
                tempArr.push(item.name)
              })
              console.log(tempArr, chooseCity, "信息")
              if(!chooseCity) {
                tempArr.forEach((item, index) => {
                  self.renderPolygon(district, item, index)
                })
              } else {
                tempArr.forEach((item, index) => {
                  if(item==chooseCity) {
                    self.renderPolygon(district, item, index)
                  } else {
                    console.log("没有当前区域")
                  }
                })
              }
              resolve()
            }
          })
        })
      },
      //渲染行政区边界
      renderPolygon(district, item, index) {
        let self=this
        let color=[
          "#f73131",
          "#fff816",
          "#ff16d8",
          "#709438",
          "#25A5F7",
          "#315EFB",
          "#771CAA",
          "#045206",
          "#6ec55e",
          "#e8ac00",
          "#f77325",
          "#1d15a0",
          "#39fda2",
        ]
        self.map.remove(self.polygons)
        self.polygons.length=[]
        district.search(item, function(status, result) {
          let bounds=result.districtList[0].boundaries
          self.polygon=null
          if(bounds) {
            for(let i=0, l=bounds.length;i<l;i++) {
              self.polygon=new AMap.Polygon({
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.4,
                fillColor: color[index],
                strokeColor: color[index],
                strokeStyle: item,
              })
              self.polygons.push(self.polygon)
            }
          }
          // self.polygon.on("click", function (e) {
          //     self.myMap.remove(self.polygons)
          //     let polygon = new AMap.Polygon({
          //         strokeWeight: 1,
          //         path: e.target.w.path,
          //         fillOpacity: 0.4,
          //         fillColor: e.target.w.strokeColor,
          //         strokeColor: e.target.w.strokeColor,
          //     })
          //     self.polygons.push(polygon)
          //     self.myMap.add(polygon)
          //     // self.map.setFitView(polygon);
          //     self.myMap.setZoom(10)
          // })
          self.map.add(self.polygons)
          self.map.add(self.polygon)
          self.map.setFitView(self.polygon) //视口自适应
        //   self.map.setFitView(self.polygons) //视口自适应
        })
      },
      handleClose() {
        this.dialogVisible=false
      },
      showFullScreen() {
        this.onFullScreen=!this.onFullScreen
        if(this.onFullScreen) {
          var docElm=document.documentElement
          if(docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if(docElm.msRequestFullscreen) {
            docElm=document.body //overwrite the element (for IE)
            docElm.msRequestFullscreen()
          } else if(docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if(docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          }
        } else {
          if(document.exitFullscreen) {
            document.exitFullscreen()
          } else if(document.msExitFullscreen) {
            document.msExitFullscreen()
          } else if(document.mozCancelFullScreen) {
            document.mozCancelFullScreen()
          } else if(document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen()
          }
        }
      },
      FullCreeen(element) {
        let el=document.getElementById("bigdata")
        let rfs=el.requestFullScreen||
          el.webkitRequestFullScreen||
          el.mozRequestFullScreen||
          el.msRequestFullScreen
        if(typeof rfs!="undefined"&&rfs) {
          rfs.call(el)
        } else if(typeof window.ActiveXObject!="undefined") {
          let wscript=new ActiveXObject("WScript.Shell")
          if(wscript!=null) {
            wscript.SendKeys("{F11}")
          }
        }
      },
      //地图加载
      loadMap() {
        return new Promise((resolve, reject) => {
          this.map=new AMap.Map("container", {
            resizeEnable: true,
            mapStyle: "amap://styles/darkblue",
            zoom: 9,
          })
          if(this.$store.state.orgAreaLevel==1||this.$store.state.orgAreaLevel==2||this.$store.state.orgAreaLevel==3) {
            let cities=[this.$store.state.orgAreaName]
            for(let i=0;i<cities.length;i++) {
              this.areaBG(this.map, cities[i])
            //   this.map.setZoom(8)
            }
          } else if(this.$store.state.orgAreaLevel==4||this.$store.state.orgAreaLevel==5) {
            console.log("社区，街道", this.$store.state.orgId)

            if(this.$store.state.orgId!=0) {
              this.$http.request({
                url: '/rbac/admin/org/info/findOrgById',
                method: 'POST',
                data: {
                  id: this.$store.state.orgId
                },
              }).then((res) => {
                var polygonArr=[]
                res.content.pointPosition
                  .split(",")
                  .forEach((i) => {
                    console.log(i)
                    polygonArr.push(i.split(":"))
                  })
                this.polygon=new AMap.Polygon({
                  map: this.map,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.2,
                  fillColor: "rgba(71,228,194,0.44)",
                  strokeColor: "rgba(83,204,79,0.65)",
                })
                this.map.setZoomAndCenter(14, [polygonArr[0].lng, polygonArr[0].lat])
                this.polygon.setMap(self.map)
              })
            }
          }
          resolve()
        })
      },
      areaBG(map, cityName) {
        console.log(cityName, "cityName")
        AMap.service("AMap.DistrictSearch", function() {
          let opts={
            subdistrict: 0,
            extensions: "all",
            level: "district", // 查询行政级别为市
          }
          // 实例化DistrictSearch
          let district=new AMap.DistrictSearch(opts)
          district.setLevel("district")
          // 行政区查询
          district.search(`${cityName}`, function(status, result) {
            // 获取边界信息
            let bounds=result.districtList[0].boundaries
            let polygons=[]
            if(bounds) {
              for(let i=0, l=bounds.length;i<l;i++) {
                // 生成行政区划polygon
                let polygon=new AMap.Polygon({
                  map: map,
                  strokeWeight: 1,
                  path: bounds[i],
                  fillOpacity: 0.2,
                  fillColor: "rgba(71,228,194,0.44)",
                  strokeColor: "rgba(83,204,79,0.65)",
                })
                polygons.push(polygon)
                console.log(polygon)
              }
            }
          })
        })
      },
      znsb() {
        this.znsbc="primary"
        this.jkdglc=""
        this.zyssc=""
        this.ylhzc=""
        this.yjyclc=""
        let znsbArry=[
          { longitude: "118.416857", latitude: "32.278072" },
          { longitude: "118.418957", latitude: "32.247872" },
          { longitude: "118.388757", latitude: "32.246772" },
          { longitude: "118.387657", latitude: "32.275972" },
          { longitude: "118.389557", latitude: "32.248672" },
        ]
        znsbArry.forEach((item) => {
          item.icons=require("./assets/img/xiaofangshuan.png")
        })

        this.showStatus=false
        this.getPoints(znsbArry)
        // request({
        //     url: "/ypt/admin/pensionServicePoint/info/findListEquipment",
        //     method: "post",
        //     data: {},
        // }).then((res) => {
        //     if (res.code == 200) {
        //         let data = res.content
        //         console.log(data)
        //         data.forEach((item) => {
        //             var marker = new AMap.Marker({
        //                 position: [item.equipmentLan, item.equipmentLat],
        //             })
        //             this.markers.push(marker)
        //             console.log(this.markers)
        //             // 将创建的点标记添加到已有的地图实例：
        //             this.map.add(this.markers)
        //             this.map.setFitView(this.markers)
        //         })
        //     }
        // })
      },
      jkdgl() {
        this.jkdglc="primary"
        this.znsbc=""
        this.zyssc=""
        this.ylhzc=""
        this.yjyclc=""
        this.showStatus=false
        let znsbArry=[
          { longitude: "118.416857", latitude: "32.278072" },
          { longitude: "118.418957", latitude: "32.247872" },
          { longitude: "118.388757", latitude: "32.246772" },
          { longitude: "118.387657", latitude: "32.275972" },
          { longitude: "118.389557", latitude: "32.248672" },
        ]
        znsbArry.forEach((item) => {
          item.icons=require("./assets/img/shiping.png")
        })

        this.showStatus=false
        this.getPoints(znsbArry)
        // request({
        //     url: "/ypt/admin/pensionServicePoint/info/findListEquipment",
        //     method: "post",
        //     data: {
        //         equipmentId: this.equipmentId,
        //     },
        // }).then((res) => {
        //     if (res.code == 200) {
        //         let data = res.content
        //         console.log(data)
        //         data.forEach((item) => {
        //             // console.log(item.equipmentLan,item.equipmentLat)
        //             var marker = new AMap.Marker({
        //                 position: [item.equipmentLan, item.equipmentLat],
        //             })
        //             this.markers.push(marker)
        //             // 将创建的点标记添加到已有的地图实例：
        //             this.map.add(this.markers)
        //             this.map.setFitView(this.markers)
        //         })
        //     }
        // })
      },
      zyss() {
        this.zyssc="primary"
        this.znsbc=""
        this.jkdglc=""
        this.ylhzc=""
        this.yjyclc=""
        this.showStatus=true
        let znsbArry=[
          { longitude: "118.416857", latitude: "32.278072" },
          { longitude: "118.418957", latitude: "32.247872" },
          { longitude: "118.388757", latitude: "32.246772" },
          { longitude: "118.387657", latitude: "32.275972" },
          { longitude: "118.389557", latitude: "32.248672" },
        ]
        znsbArry.forEach((item) => {
          item.icons=require("./assets/img/marker2.png")
        })

        this.showStatus=false
        this.getPoints(znsbArry)
        // request({
        //     url: "/ypt/admin/monitorVo/zyss",
        //     method: "post",
        //     data: {},
        // }).then((res) => {
        //     if (res.code == 200) {
        //         let data = res.content
        //         console.log(data)
        //         data.forEach((item) => {
        //             // console.log(item.longitude,item.latitude)
        //             var marker = new AMap.Marker({
        //                 position: [item.longitude, item.latitude],
        //             })
        //             this.markers.push(marker)
        //             // // 将创建的点标记添加到已有的地图实例：
        //             this.map.add(this.markers)
        //             this.map.setFitView(this.markers)
        //         })
        //     }
        // })
      },
      ylhz() {
        this.ylhzc="primary"
        this.znsbc=""
        this.jkdglc=""
        this.zyssc=""
        this.yjyclc=""
        this.showStatus=false
        let znsbArry=[
          { longitude: "118.416857", latitude: "32.278072" },
          { longitude: "118.418957", latitude: "32.247872" },
          { longitude: "118.388757", latitude: "32.246772" },
          { longitude: "118.387657", latitude: "32.275972" },
          { longitude: "118.389557", latitude: "32.248672" },
        ]
        znsbArry.forEach((item) => {
          item.icons=require("./assets/img/end_icon.png")
        })

        this.showStatus=false
        this.getPoints(znsbArry)
        // request({
        //     url: "/ypt/admin/monitorVo/ylhz",
        //     method: "post",
        //     data: {},
        // }).then((res) => {
        //     if (res.code == 200) {
        //         let data = res.content
        //         console.log(data)
        //         data.forEach((item) => {
        //             // console.log(item.longitude,item.latitude)
        //             var marker = new AMap.Marker({
        //                 position: [item.longitude, item.latitude],
        //             })
        //             this.markers.push(marker)
        //             // // 将创建的点标记添加到已有的地图实例：
        //             this.map.add(this.markers)
        //             this.map.setFitView(this.markers)
        //         })
        //     }
        // })
      },
      yjycl() {
        this.yjyclc="primary"
        this.znsbc=""
        this.jkdglc=""
        this.zyssc=""
        this.ylhzc=""
        this.showStatus=false
        let znsbArry=[
          { longitude: "118.416857", latitude: "32.278072" },
          { longitude: "118.418957", latitude: "32.247872" },
          { longitude: "118.388757", latitude: "32.246772" },
          { longitude: "118.387657", latitude: "32.275972" },
          { longitude: "118.389557", latitude: "32.248672" },
        ]
        znsbArry.forEach((item) => {
          item.icons=require("./assets/img/sos.gif")
        })

        this.showStatus=false
        this.getPoints(znsbArry)
        // request({
        //     url: "/ypt/admin/monitorVo/yjycl",
        //     method: "post",
        //     data: {},
        // }).then((res) => {
        //     if (res.code == 200) {
        //         let data = res.content
        //         console.log(data)
        //         data.forEach((item) => {
        //             // console.log(item.longitude,item.latitude)
        //             var marker = new AMap.Marker({
        //                 position: [item.longitude, item.latitude],
        //             })
        //             this.markers.push(marker)
        //             // // 将创建的点标记添加到已有的地图实例：
        //             this.map.add(this.markers)
        //             this.map.setFitView(this.markers)
        //         })
        //     }
        // })
      },
      // 打点
      getPoints(data) {
        const self=this
        self.map.remove(self.markers)
        self.markers=[]
        data.forEach((item) => {
          if(item.longitude&&item.latitude) {
            let marker=new AMap.Marker({
              position: [item.longitude, item.latitude],
              icon: new AMap.Icon({
                image: item.icons,
                size: new AMap.Size(50, 50),
                imageSize: new AMap.Size(20, 20),
              }),
              // extData: {
              //     id: item.id,
              //     name: item.customerName,
              //     sex: item.gender, //0男1女
              //     age: item.age,
              //     phone: item.phone,
              //     address: item.address,
              //     photo: item.photo,
              // },
            })
            self.markers.push(marker)
            // marker.on("click", self.maskModel)
          }
        })
        this.map.add(self.markers)
      },
    },
    get methods() {
      return this._methods
    },
    set methods(value) {
      this._methods=value
    },
}
</script>

<style lang="less" scoped>
#container {
    position: absolute;
    left: 0;
    right: 0;
    top: 100px;
    bottom: 0;
    z-index: 1;
}
.customerTop {
        img {
            width: 100%;
            height: 88px;
        }
        h1 {
            color: #6ebcff;
            position: absolute;
            text-align: center;
            font-weight: 500;
            font-size: 30px;
            left: 0;
            top: -6px;
            width: 100%;
            height: 78px;
            line-height: 78px;
            z-index: 3;
        }
        .titleFirst {
            min-width: 560px;
            position: absolute;
            width: 560px;
            // border-top: 78px solid #1e69b6;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -310px;
            z-index: 2;
        }
        .titleSecond {
            min-width: 620px;
            width: 620px;
            position: absolute;
            // border-top: 78px solid #103b71;
            border-left: 40px solid transparent;
            border-right: 40px solid transparent;
            height: 0;
            left: 50%;
            top: 0;
            margin-left: -340px;
        }
    }
.nameoftransition-enter-active,
.nameoftransition-leave-active {
    transition: opacity 0.5s;
}

.nameoftransition-enter,
	.nameoftransition-leave-to

	/* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

//引入的字体样式
@font-face {
    font-family: "Unidtrsmled";
    src: url(./assets/font/UnidreamLED.ttf);
}

.quanp {
    width: 200px;
    height: 100px;
    float: right;
    position: absolute;
    top: 20px;
    right: -110px;

    button {
        padding: 10px;
    }
}

.bigdata_container {
    * {
        box-sizing: content-box;
    }
}

/deep/ .el-carousel__container {
    height: 100% !important;

    .el-icon-arrow-left:before,
    .el-icon-arrow-right:before {
        color: #489aff;
        font-weight: bold;
        font-size: 22px;
    }
}

.bigdata_container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url("./assets/img/bg.png") no-repeat center center;
    background-size: 100% 100%;

    .header {
        margin: auto;
        width: 90%;
        height: 100px;
        background: url("./assets/img/dateTop1.png") no-repeat center center;
        background-size: 100%;
    }
}

.date-left {
    width: 22%;
    margin-left: 1%;
    margin-top: 1%;
    padding: 1% 1% 0.3% 1%;
    border: 1px solid #2e48a0;
    z-index: 90;
    position: relative;
}
.date-title {
    width: 100%;
    display: flex;
}

.date-title > div:first-child {
    line-height: 30px;
    border-left: 4px solid #29dce3;
    font-size: 15px;
    color: #29dce3;
    padding-left: 15px;
    width: 95%;
    // margin: 0 auto;
    background-image: linear-gradient(
        to right,
        rgba(69, 214, 216, 0.3),
        rgba(0, 0, 0, 0)
    );
}

.date-list {
    width: 100%;
    display: flex;
    align-items: center;
}

.icon-title {
    width: 33%;
    text-align: center;
}

.icon-title > div:first-child {
    margin: 20px 0 0 0;
}

.icon-title > div:nth-child(2) {
    margin: 10px 0 0 0;
}

.icon-title > div:nth-child(3) {
    margin: 10px 0 0 0;
}

.main_center {
    position: absolute;
    top: 10%;
    left: 1%;
    overflow-y: auto;
    z-index: 10;
}

.date-center1 {
    width: 46%;
    margin-left: 1%;
    padding: 1% 1%;
    background: url(./assets/img/a3.png);
    background-size: 100% 100%;
    z-index: 90;
    position: absolute;
    left: 24.5%;
    bottom: 0.1%;
}

.date-center2 {
    top: 1%;
    width: 46%;
    margin-left: 26%;
    z-index: 90;
    position: absolute;
}

.date-goog {
    width: 95%;
    display: flex;
    line-height: 30px;
    border-left: 4px solid #29dce3;
    font-size: 15px;
    color: #29dce3;
    padding-left: 15px;
    justify-content: space-between;
    margin: 0 auto;
    background-image: linear-gradient(
        to right,
        rgba(69, 214, 216, 0.3),
        rgba(0, 0, 0, 0)
    );
}

.date-right {
    width: 22%;
    margin-left: 1%;
    margin-top: 1%;
    padding: 1% 1% 0.9% 1%;
    border: 1px solid #2e48a0;
    z-index: 90;
    position: absolute;
    right: 1.5%;
    top: -2%;
    bottom: 0.1%;
}
</style>
